import { AnyAction } from 'redux';
import { GlobalActions } from '@ps20-frontend/shop-integration-redux';
import { AktionsNachlass } from '@ps20-frontend/frontend-models';
import { IAppState } from '@ps20-frontend/apps/dashboard-store';

export const kooperationReducer = function (
  sectionState: string = null,
  action: AnyAction,
  state: IAppState,
): string {
  switch (action.type) {
    case GlobalActions.UPDATE_AKTIONSNACHLASS_CODE: {
      const actionPayload: AktionsNachlass = action.payload;
      if (actionPayload.name && isValidNachlassCode(state, actionPayload.code)) {
        return actionPayload.code;
      }
      break;
    }
    case GlobalActions.CHECK_VALID_AKTIONSNACHLASS_CODE: {
      if (!isValidNachlassCode(state, sectionState)) {
        return null;
      } else {
        return sectionState;
      }
    }
    default:
      return sectionState;
  }
};

const isValidNachlassCode = (state: IAppState, nachlassCodeName: string): boolean =>
  state.transientState.kooperationen?.map(value => value?.code).includes(nachlassCodeName) ||
  !nachlassCodeName;
